export const GRETA_AI_CHAT_CHAT_LIST_SKELETON_SECTIONS = [
  { itemWidths: ['86%', '64%', '78%'], titleWidth: '28%' },
  { itemWidths: ['72%', '58%'], titleWidth: '36%' },
]

export const QA_NAME_GRETA_AI_CHAT_CHAT_LIST_SKELETON =
  'gretaAIChatChatListSkeleton'
